import { logger } from 'adapters/Logger';

import type { OfferUnavailableLogReason } from '../types';

/**
 * FIN-8016: registra cada desvio para a página de obrigado. Só identificadores
 * da oferta; nunca nome, e-mail, telefone, documento ou leadId (PCI/LGPD).
 */
export function logOfferUnavailable({
  operation,
  planId,
  productCode,
  reason,
  messageCode,
  business,
}: {
  operation: 'lead-diversion' | 'payment-refused' | 'payment-page-diversion';
  planId: string | null | undefined;
  productCode: string | null | undefined;
  reason: OfferUnavailableLogReason;
  /** Código cru do /v3/payment, só na recusa do pagamento. */
  messageCode?: string;
  business: string | null | undefined;
}) {
  logger.warning(
    new Error('Offer unavailable'),
    { flow: 'offer-availability', operation },
    {
      planId: planId ?? null,
      productCode: productCode ?? null,
      reason,
      ...(messageCode && { messageCode }),
      business: business ?? null,
    }
  );
}
